<template>
    <client-page class="app--main">
        <div class="visual poppins mb-lg-120">
            <div class="visual-inner">
                <v-container>
                    <div class="visual-contents">
                        <img src="/images/ci-light.svg" alt="" />
                        <p>INTEGRATED SYSTEM TECHNOLOGY</p>
                    </div>
                    <div class="scr-wrap d-none d-lg-flex">
                        <p>scroll down</p>
                        <div class="scr"></div>
                    </div>
                </v-container>
            </div>
            <div class="visual-vod">
                <video playsinline muted autoplay loop poster="/images/main/visual.png">
                    <source src="/res/main/visual.mp4" type="video/mp4" />
                    <strong>Your web browser does not support video.</strong>
                </video>
            </div>
        </div>

        <section class="main-section main-section1 pt-80 pt-md-100 pt-lg-140 pb-100 pb-md-120 pb-lg-160 border-bottom">
            <v-container>
                <div class="section-title pt-lg-50 mb-32 mb-lg-130">
                    <h2>PRODUCT</h2>
                </div>
                <v-row class="mx-xl-n64 my-xl-n30 s1-item-group">
                    <v-col cols="12" md="6" class="px-xl-64 py-xl-30">
                        <a href="/en/products/CMP" class="s1-item s1-item2 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img2.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Machining Products</p>
                                <h4 class="poppins tit font-weight-medium">CMP Retainer - Ring</h4>
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                        <a href="/en/products/metal" class="s1-item s1-item4 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img4.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Machining Products</p>
                                <h4 class="poppins tit font-weight-medium">Metal</h4>
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                        <a href="/en/products/engineering" class="s1-item s1-item6 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img6.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Machining Products</p>
                                <h4 class="poppins tit font-weight-medium">
                                    Engineering <br class="pc" />
                                    Plastic & Rubber
                                </h4>
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                    </v-col>
                    <v-col cols="12" md="6" class="px-xl-64 py-xl-30">
                        <a href="/en/distributor/kalrez" class="s1-item s1-item1 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img8.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Distributor in Korea</p>
                                <v-img src="/images/logos/kalrez.png" alt="DUPONT Kalrez" class="dupont--kalrez" />
                                <!-- <h4 class="poppins tit font-weight-medium">Dupont Kalrez®</h4> -->
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                        <a href="/en/distributor/dupont" class="s1-item s1-item1 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img1.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Distributor in Korea</p>
                                <v-img src="/images/logos/vespel.png" alt="DUPONT Vespel" class="dupont dupont--vespel" />
                                <!-- <h4 class="poppins tit font-weight-medium">Dupont Vespel®</h4> -->
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                        <a href="/en/distributor/endo" class="s1-item s1-item3 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60">
                            <img src="/images/main/prd-img3.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Distributor in Korea</p>
                                <h4 class="poppins tit font-weight-medium">ENDO Metal-Sleeve</h4>
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                        <a href="/en/distributor/oring" class="s1-item s1-item5 w-100 arrow-button-wrap">
                            <img src="/images/main/prd-img5.png" alt="" class="d-block w-100" />
                            <div class="s1-txt">
                                <p class="font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey">Distributor in Korea</p>
                                <h4 class="poppins tit font-weight-medium">Mitsubishi O-Ring</h4>
                            </div>
                            <button class="arrow-button white round">
                                <img src="/images/common/arrow.svg" alt="" class="d-block arrow-show" />
                            </button>
                        </a>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="main-section main-section2 py-100 py-md-120 py-lg-160">
            <v-container lg>
                <div class="section-title text-center mb-32 mb-lg-50">
                    <h2>What We Do</h2>
                </div>

                <div class="bg-grey pa-30 py-md-50 pt-lg-160 pb-lg-110 mb-32 mb-lg-50">
                    <img src="/images/main/s2-img-en.png" alt="" class="d-none d-md-block mx-auto" />
                    <img src="/images/main/s2-img-mo-en.png" alt="" class="d-block d-md-none mx-auto" />
                </div>

                <v-tabs v-model="tab" centered center-active class="mb-18 mb-lg-30 poppins">
                    <v-tab> Safety Management </v-tab>
                    <v-tab> Security Management </v-tab>
                    <v-tab> Quality Control </v-tab>
                    <v-tab> Smart Factory </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-row class="row--large flex-column-reverse flex-xl-row">
                            <v-col cols="12" xl="6" class="mt-20 mt-lg-40 mt-xl-0">
                                <div class="h-100 w-100 border-bottom d-flex flex-column justify-center s2-item">
                                    <h3 class="poppins tit--lg font-weight-semibold mb-12 mb-lg-24">SAFETY MANAGEMENT</h3>
                                    <p class="tit-txt color-gery-51">
                                        We are establishing an occupational Health and Safety Management System for worker safety. <br />
                                        Consulting and requirements for periodic management of occupational safety management are being updated.
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" xl="6">
                                <img src="/images/main/wwd-img1.png" alt="" class="d-block w-100" />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="row--large flex-column-reverse flex-xl-row">
                            <v-col cols="12" xl="6" class="mt-20 mt-lg-40 mt-xl-0">
                                <div class="h-100 w-100 border-bottom d-flex flex-column justify-center s2-item">
                                    <h3 class="poppins tit--lg font-weight-semibold mb-12 mb-lg-24">SECURITY MANAGEMENT</h3>
                                    <p class="tit-txt color-gery-51">
                                        Customer's information is the same as assets, so it is managed and protected first. Using a security safety program, data taken out or brought in is systematically managed. <br />
                                        It has obtained ISO 27001 certification and is operating as one of the management systems.
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" xl="6">
                                <img src="/images/main/wwd-img2.png" alt="" class="d-block w-100" />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="row--large flex-column-reverse flex-xl-row">
                            <v-col cols="12" xl="6" class="mt-20 mt-lg-40 mt-xl-0">
                                <div class="h-100 w-100 border-bottom d-flex flex-column justify-center s2-item">
                                    <h3 class="poppins tit--lg font-weight-semibold mb-12 mb-lg-24">QUALITY CONTROL</h3>
                                    <p class="tit-txt color-gery-51">
                                        ISO 9001 Quality Management System The entire process, according to the procedure and efficient system of quality control operations. <br />
                                        Analyzing trends and ensuring stable quality through SPC systems.
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" xl="6">
                                <img src="/images/main/wwd-img3.png" alt="" class="d-block w-100" />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="row--large flex-column-reverse flex-xl-row">
                            <v-col cols="12" xl="6" class="mt-20 mt-lg-40 mt-xl-0">
                                <div class="h-100 w-100 border-bottom d-flex flex-column justify-center s2-item">
                                    <h3 class="poppins tit--lg font-weight-semibold mb-12 mb-lg-24">SMART FACTORY</h3>
                                    <p class="tit-txt color-gery-51">
                                        Application of ICT (Information Communication Technology) that combines digital automation solutions in the production process. <br class="main-s2-pc" />
                                        Introduction of processes that collect process data in real time and analyze themselves through IoT
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" xl="6">
                                <img src="/images/main/wwd-img4.png" alt="" class="d-block w-100" />
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </section>

        <section class="main-section main-section3 poppins">
            <v-row no-gutters>
                <v-col cols="12" sm="4">
                    <a href="/en/about/histroy" class="s3-item s3-item1 w-100 arrow-button-wrap">
                        <span class="line line1"></span>
                        <span class="line line2"></span>
                        <span class="line line3"></span>
                        <span class="line line4"></span>
                        <img src="/images/main/quick-img1.png" alt="" class="d-block w-100" />
                        <h6 class="font-weight-semibold font-size-18 font-size-lg-28 w-100">Company History</h6>
                        <button class="arrow-button sm round point-light">
                            <img src="/images/common/arrow-w.svg" alt="" class="d-block" />
                        </button>
                    </a>
                </v-col>
                <v-col cols="12" sm="4">
                    <a href="/en/about/partner" class="s3-item s3-item2 w-100 arrow-button-wrap">
                        <span class="line line1"></span>
                        <span class="line line2"></span>
                        <span class="line line3"></span>
                        <span class="line line4"></span>
                        <img src="/images/main/quick-img2.png" alt="" class="d-block w-100" />
                        <h6 class="font-weight-semibold font-size-18 font-size-lg-28 w-100">Partners</h6>
                        <button class="arrow-button sm round point-light">
                            <img src="/images/common/arrow-w.svg" alt="" class="d-block" />
                        </button>
                    </a>
                </v-col>
                <v-col cols="12" sm="4">
                    <a href="/en/about/status" class="s3-item s3-item3 w-100 arrow-button-wrap">
                        <span class="line line1"></span>
                        <span class="line line2"></span>
                        <span class="line line3"></span>
                        <span class="line line4"></span>
                        <img src="/images/main/quick-img3.png" alt="" class="d-block w-100" />
                        <h6 class="font-weight-semibold font-size-18 font-size-lg-28 w-100">Certification Status</h6>
                        <button class="arrow-button sm round point-light">
                            <img src="/images/common/arrow-w.svg" alt="" class="d-block" />
                        </button>
                    </a>
                </v-col>
            </v-row>
        </section>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import PopupLayer from "@/components/client/ko/popup/popup-layer.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        PopupLayer,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
};
</script>

<style lang="scss" scoped>
.visual {
    width: 100%;
    height: 0;
    padding-top: calc((1080 / 1920) * 100%);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
}

.visual-inner {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.6);
}

.visual-vod {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}

.visual-vod video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

video[poster] {
    height: 100%;
    width: 100%;
}

.scr-wrap {
    position: absolute;
    left: 50%;
    bottom: 70px;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.scr-wrap p {
    font-size: 1.4rem;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 1;
    margin-bottom: 8px;
}

.scr-wrap .scr {
    width: 22px;
    height: 34px;
    border: 2px solid #dfdfdf;
    border-radius: 11px;
    position: relative;
}

.scr-wrap .scr::after {
    content: "";
    display: block;
    position: absolute;
    width: 2px;
    height: 6px;
    background-color: #fff;
    top: 8px;
    left: 8px;
    border-radius: 1px;
    animation: scr 1.2s linear infinite;
}

@keyframes scr {
    0% {
        opacity: 0;
        top: 8px;
    }

    20% {
        opacity: 1;
    }

    70% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        top: 14px;
    }
}

.visual-contents {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    text-align: center;
    opacity: 0;
    animation: visual 3s 1s ease forwards;
}

.visual-contents img {
    width: 100px;
    margin-bottom: 12px;
    display: block;
}

.visual-contents p {
    font-weight: 500;
    font-size: 1.6rem;
}

@keyframes visual {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@media (min-width: 576px) {
    .visual-contents img {
        width: 120px;
        margin-bottom: 20px;
    }

    .visual-contents p {
        font-size: 2rem;
    }
}
@media (min-width: 768px) {
    .visual-contents img {
        width: 180px;
    }

    .visual-contents p {
        font-size: 2.6rem;
    }
}
@media (min-width: 1024px) {
    .visual {
        height: calc(100vh - var(--header-body));
        padding-top: 0;
    }

    .visual-inner {
        position: relative;
    }

    .visual-contents img {
        width: 244px;
        margin-bottom: 28px;
    }

    .visual-contents p {
        font-size: 3.2rem;
    }
}
@media (min-width: 1200px) {
}

.dupont {
    &--kalrez {
        max-width: 290px;
    }
    &--vespel {
        max-width: 270px;
    }
}

@media (min-width: 1024px) {
    .dupont {
        &--kalrez {
            max-width: 386px;
        }
        &--vespel {
            max-width: 332px;
        }
    }
}
</style>